module.exports = __webpack_public_path__ + "img/bookshelf_bg.896a566c.png";